'use client';

import {
  BottomSheetHandleArea,
  BottomSheetTitle,
  BottomSheetTitleBox,
  BottomSheetTitleContainer,
  Dim,
  IcDelete,
  IconButton,
  Padding,
  Sheet,
  SheetContent,
  SheetDimMotion,
  SheetMotion,
  SheetPortal,
  SheetTrigger,
  Typography,
} from '@musinsa/mds';
import type React from 'react';
import { useState } from 'react';
import { usePreventBodyScroll } from '../../../common/hooks/usePreventBodyScroll';
import { GoToMusinsaPrivacyPolicyLink } from './GoToMusinsaPrivacyPolicy';

interface IdNumberInfoBottomSheetProps {
  children: React.ReactNode;
}

export const IdNumberInfoBottomSheet = ({ children }: IdNumberInfoBottomSheetProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // 바텀시트 열렸을 때 뒤쪽 스크롤 방지
  usePreventBodyScroll({ open: isOpen });

  return (
    <Sheet direction="bottom" defaultOpen={false} open={isOpen}>
      <SheetTrigger asChild onClick={() => setIsOpen(true)}>
        {children}
      </SheetTrigger>
      <SheetPortal>
        <SheetContent onPointerDownOutside={() => setIsOpen(false)}>
          <SheetMotion direction="bottom">
            <BottomSheetTitle className="pb-2.5">
              <BottomSheetHandleArea />
              <BottomSheetTitleContainer>
                <BottomSheetTitleBox>
                  <Typography TextEtc16pxMed>주민등록번호 처리 안내</Typography>
                </BottomSheetTitleBox>
                <IconButton size="size28x28" onClick={() => setIsOpen(false)}>
                  <IcDelete />
                </IconButton>
              </BottomSheetTitleContainer>
            </BottomSheetTitle>
            <IdNumberInfoBottomSheetContent />
          </SheetMotion>
        </SheetContent>
        <SheetDimMotion>
          <Dim />
        </SheetDimMotion>
      </SheetPortal>
    </Sheet>
  );
};

const IdNumberInfoBottomSheetContent = () => {
  return (
    <div className="flex flex-col px-4 bg-white safe-area-bottom">
      <div className="flex flex-col pb-[12px]! gap-[4px]">
        <Padding>
          <Typography variant="body13pxReg">
            (주)무신사는 관련 법규에 의하여 주민등록번호를 수집 및 이용합니다. 아래의 내용을 잘 확인
            부탁드립니다.
          </Typography>
        </Padding>
        <ul>
          <li className="flex gap-[4px] py-1">
            <Typography variant="body13pxReg">•</Typography>
            <Typography variant="body13pxReg">처리하는자: (주)무신사</Typography>
          </li>
          <li className="flex gap-[4px] py-1">
            <Typography variant="body13pxReg">•</Typography>
            <Typography variant="body13pxReg">수집 및 이용 목적: 큐레이터 정산을 위함</Typography>
          </li>
          <li className="flex gap-[4px] py-1">
            <Typography variant="body13pxReg">•</Typography>
            <Typography variant="body13pxReg">
              수집 및 이용 항목: 주민등록번호, 신분증 사본(주민등록번호)
            </Typography>
          </li>
          <li className="flex gap-[4px] py-1">
            <Typography variant="body13pxReg">•</Typography>
            <Typography variant="body13pxReg">
              보유 및 이용 기간: 소득세법 및 국세기본법에 의해 5년간 보관 후 파기
            </Typography>
          </li>
          <li className="flex gap-[4px] py-1">
            <Typography variant="body13pxReg">•</Typography>
            <Typography variant="body13pxReg">
              관련 법규 : 소득세법 제19조(사업소득), 제21조(기타소득), 제127조(원천징수의무),
              제144조(사업소득에 대한 원천징수 시기와 방법 및 원천징수영수증의 발급),
              제145조(기타소득에 대한 원천징수 시기와 방법 및 원천징수 영수증의 발급),
              제164조(지급명세서의 제출), 제165조(소득공제 및 세액공제 증명 서류의 제출 및
              행정지도), 소득세법 시행령 제193조(원천징수영수증의 교부),부가가치세법
              제32조(세금계산서 등), 국세기본법 시행령 제68조(민감정보 및 고유식별정보의 처리)
            </Typography>
          </li>
        </ul>
        <Padding>
          <Typography variant="body13pxReg">
            수집한 주민등록번호는 수집 및 이용 목적 외의 목적으로는 이용하지 않으며, 보유 및
            이용기간이 만료되면 복구가 불가능하게 파기합니다.
          </Typography>
        </Padding>
        <Padding>
          <Typography variant="body13pxReg">
            자세한 내용은{' '}
            <GoToMusinsaPrivacyPolicyLink>개인정보처리방침</GoToMusinsaPrivacyPolicyLink>을 확인
            부탁드립니다.
          </Typography>
        </Padding>
      </div>
    </div>
  );
};
